import styled from 'styled-components';

const Container = styled.div`
	all: unset;
	width: 100%;
	min-width: 134px;
	box-sizing: border-box;
	background-color: ${({theme}) => theme.colors.light.background.paper};
	height: 54px;
	padding: 8px 16px;
	border-radius: 8px;
	border: 1px solid ${({theme}) => theme.colors.gray['50Percent']};
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 0.875rem;
	color: ${({theme}) => theme.colors.gray['50Percent']};
	font-weight: 400;
	white-space: nowrap;
`;

const IconContainer = styled.span`
	color: inherit;
	width: 20px;
	height: 20px;

	svg {
		display: block;
		width: 100%;
		height: 100%;
	}
`;

export {Container, IconContainer};
